import React from 'react';
import { Menu } from 'antd';

const WorkerDropdownMenu = ({
  worker,
  onChangeWorkerClick,
  onCallClick,
  ...props
}) => {
  return (
    <Menu {...props}>
      {typeof onChangeWorkerClick === 'function' && (
        <Menu.Item onClick={onChangeWorkerClick}>
          {worker.id
            ? `Сменить ${worker.text}`
            : `Назначить ${worker.text}`}
        </Menu.Item>
      )}
      {typeof onCallClick === 'function' && (
        <Menu.Item onClick={onCallClick}>Позвонить</Menu.Item>
      )}
    </Menu>
  );
};

export default WorkerDropdownMenu;
